import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, saveToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        // Parse session_id from hash
        const hash = location.hash || window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/emergent/session", { session_id: sessionId });
                if (data.token) saveToken(data.token);
                // Clear hash
                window.history.replaceState(null, "", window.location.pathname);
                const user = await refresh();
                if (!user) {
                    navigate("/login", { replace: true });
                    return;
                }
                if (!user.profile_complete) navigate("/onboarding/profile", { replace: true });
                else if (!user.vibe_complete) navigate("/onboarding/vibe", { replace: true });
                else navigate("/app/match", { replace: true });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        })();
    }, [location.hash, navigate, refresh]);

    return (
        <div className="min-h-screen grid place-items-center bg-background">
            <div className="animate-pulse text-muted-foreground" data-testid="auth-callback-loading">Signing you in…</div>
        </div>
    );
}
